// hooks/useInitDoubleBarChart.ts
import { YAxisOptions } from 'highcharts';
import { useDoubleBarChart } from '@components/design/migrated/DoubleBarChart/hooks';
import { useExportContext } from '@hooks/export/context/ExportContext';
import { Dimensions, OnExportReadyCallback, useRegisterChartForExport } from '@ecosystem/export-utils';
import { EXPORT_RENDERING_RESOLUTION } from '@hooks/export/Model';
import { ChartScales } from '@data-visualization/performance-segment-mulitple-chart/hooks/UsePerformanceSegmentMultipleChartScales';
import { isEmpty } from '@utils/ObjectUtils';

type Params = {
  chartOptions: any;
  chartScales?: ChartScales;
  index?: number;
  onExportReady: OnExportReadyCallback;
  dimensions?: Dimensions;
};

export const useInitDoubleBarChart = ({ chartOptions, chartScales, index, onExportReady, dimensions }: Params) => {
  const { options, chartRef, handleChartCallback } = useDoubleBarChart(chartOptions);
  const { setChartRefsIsInitialisedStatus } = useExportContext();

  if (chartScales && index !== undefined) {
    const yAxisOptions = options.yAxis as YAxisOptions[];
    yAxisOptions[0].max = chartScales.maxLeft;
    yAxisOptions[1].max = chartScales.maxRight;
    yAxisOptions[1].min = chartScales.minRight;

    setChartRefsIsInitialisedStatus((prev) => {
      if (isEmpty(chartRef.current) || prev[index]) return prev;
      const next = [...prev];
      next[index] = true;
      return next;
    });
  }

  useRegisterChartForExport(chartRef, onExportReady, dimensions, EXPORT_RENDERING_RESOLUTION, undefined, []);

  return { options, chartRef, chartCallback: handleChartCallback };
};
